import {
    HEATMAP_SOCKET_PARAM_KEY,
    HEATMAP_COLLECT_WS,
    getCookie,
} from './heatmap-common.js';

export const heatmapSocketCv = () => {
  try {
    const raw = getCookie(HEATMAP_SOCKET_PARAM_KEY);
    const postData = JSON.parse(raw);
    if(postData) {
      postData.cv = true;
      
      const ajaxUrl = HEATMAP_COLLECT_WS;
      const payload = JSON.stringify(postData);
      const ok = navigator.sendBeacon(ajaxUrl, payload);

      if(!ok) {
        fetch(ajaxUrl, {method: 'POST', body: payload, keepalive: true}).catch(() => {});
      }
    }
  } catch (e) {};
};